export function createDedupedFetcher<T>(fetcher: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null;

  return () => {
    if (inFlight) {
      return inFlight;
    }

    inFlight = fetcher().finally(() => {
      inFlight = null;
    });

    return inFlight;
  };
}
